import type { ReactElement } from 'react'
import { ProfilesList } from '~/components/Global/Elements/ProfilesList/ProfilesList'

export type ContactsListProps = {
  contactIds: number[]
  className?: string
  tooltipText?: string
  maxProfilesCount?: number
}

export const ContactsList = ({
  contactIds,
  className,
  maxProfilesCount = 20,
  tooltipText
}: ContactsListProps): ReactElement => (
  <ProfilesList
    contactIds={contactIds}
    tooltipText={tooltipText}
    className={className}
    maxProfilesCount={maxProfilesCount}
  />
)
